import React from "react";
import "../App.css";
import "./HeroSection.css";

function HeroSection() {
  return (
    <div className="hero-container">
  
      <h1>Learn to speak, read and write in Filipino language</h1>
      
    </div>
  );
}

export default HeroSection;
